<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på betalvillkor</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';

export default {
    name: 'PayDaysFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: [
                {
                    id: 0,
                    label: '0 dagar',
                },
                {
                    id: 10,
                    label: '10 dagar',
                },
                {
                    id: 14,
                    label: '14 dagar',
                },
                {
                    id: 15,
                    label: '15 dagar',
                },
                {
                    id: 20,
                    label: '20 dagar',
                },
                {
                    id: 30,
                    label: '30 dagar',
                },
                {
                    id: 40,
                    label: '40 dagar',
                },
                {
                    id: 45,
                    label: '45 dagar',
                },
                {
                    id: 60,
                    label: '60 dagar',
                },
                {
                    id: 93,
                    label: '96 dagar',
                },
            ],
        };
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>
